import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SimpleLandingPage from "./pages/SimpleLandingPage";
import GeneratorPage from "./pages/GeneratorPage";
import FavoritesPage from "./pages/FavoritesPage";
import SavedSessionsPage from "./pages/SavedSessionsPage";
import ContactPage from "./pages/ContactPage";
import ShareSessionPage from "./pages/ShareSessionPage";
import NotFoundPage from "./pages/NotFoundPage";
import UnderConstructionPage from "./pages/UnderConstructionPage";
import { Toaster } from "react-hot-toast";
import { Layout } from "./components";
import { FavoritesProvider } from "./context/FavoritesContext";
import { CreditsProvider } from "./context/CreditsContext";
import config from "./config";
import ProtectedRoute from "./auth/ProtectedRoute";
import { Analytics } from "@vercel/analytics/react";


function App() {
  const isOfflineMode = config.isOfflineMode;

  return (
    <CreditsProvider>
      <FavoritesProvider>
        <Toaster position="top-center" />
        <Router>
          <Routes>
            <Route path="/" element={<SimpleLandingPage />} />
            <Route path="/marketing" element={<LandingPage />} />
            <Route path="/app" element={<GeneratorPage />} />
            <Route path="/saved" element={
              isOfflineMode ? <UnderConstructionPage /> : (
                <ProtectedRoute>
                  <Layout>
                    <SavedSessionsPage />
                  </Layout>
                </ProtectedRoute>
              )
            } />
            <Route path="/share/:id" element={
              isOfflineMode ? <UnderConstructionPage /> : (
                <Layout>
                  <ShareSessionPage />
                </Layout>
              )
            } />
            <Route path="/favorites" element={
              isOfflineMode ? <UnderConstructionPage /> : (
                <ProtectedRoute>
                  <Layout>
                    <FavoritesPage />
                  </Layout>
                </ProtectedRoute>
              )
            } />
            <Route path="/contact" element={
              isOfflineMode ? <UnderConstructionPage /> : (
                <Layout>
                  <ContactPage />
                </Layout>
              )
            } />
            <Route path="/pricing" element={<UnderConstructionPage />} />
            <Route path="/blog" element={<UnderConstructionPage />} />
            <Route path="/blog/:slug" element={<UnderConstructionPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </FavoritesProvider>
      <Analytics />
    </CreditsProvider>
  );
}

export default App;
